import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import A1 from "../Images/WhatsApp Image 2026-01-20 at 12.46.23 PM.jpeg";

const BASE_URL = "https://taaiappapi.emedha.in/pages/api"; // backend URL

const Offers = () => {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // Form states
  const [title, setTitle] = useState("");
  const [discount, setDiscount] = useState("");
  const [image, setImage] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");

  // --- Date helpers ---
  const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";

    // Already yyyy-mm-dd
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;

    // dd/mm/yyyy
    if (dateStr.includes("/")) {
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month}-${day}`;
    }

    // ISO string
    const date = new Date(dateStr);
    if (!isNaN(date)) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    }

    return "";
  };

  const formatDateToDisplay = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date)) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // --- Fetch offers ---
  const fetchOffers = async () => {
    try {
      const res = await fetch(`${BASE_URL}/get/offers/`);
      const data = await res.json();
      console.log(data);
      // Normalize dates for input
      setOffers(
        data.map((offer) => ({
          ...offer,
          startDate: formatDateForInput(offer.start_date),
          expiryDate: formatDateForInput(offer.expiry_date),
        }))
      );
    } catch (err) {
      console.error("Error fetching offers:", err);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  // --- Navigation ---
  const handleBackToDashboard = () => {
    navigate("/agency-dashboard", { replace: true });
  };

  // --- Generate coupon ---
  const generateCoupon = (percent) => {
    return `TAAI${percent}${Math.floor(1000 + Math.random() * 9000)}`;
  };

  // --- Add or update offer ---
  const handleSubmit = async () => {
    if (!title || !discount || !startDate || !expiryDate) {
      alert("Please fill all required fields");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("discount", discount);
    formData.append("coupon", generateCoupon(discount));
    formData.append("start_date", startDate);
    formData.append("expiry_date", expiryDate);
    if (image) formData.append("image", image);

    try {
      let res;
      if (editingId) {
        res = await fetch(`${BASE_URL}/put/offers/${editingId}`, {
          method: "PUT",
          body: formData,
        });
      } else {
        res = await fetch(`${BASE_URL}/post/offers/`, {
          method: "POST",
          body: formData,
        });
      }

      await res.json();
      fetchOffers(); // refresh list

      // Reset form
      setTitle("");
      setDiscount("");
      setImage(null);
      setStartDate("");
      setExpiryDate("");
      setEditingId(null);
      setShowForm(false);
    } catch (err) {
      console.error("Error saving offer:", err);
    }
  };

  // --- Edit offer ---
  const handleEdit = (offer) => {
    setTitle(offer.title);
    setDiscount(offer.discount);
    setStartDate(offer.startDate); // already normalized
    setExpiryDate(offer.expiryDate); // already normalized
    setEditingId(offer.id);
    setImage(null);
    setShowForm(true);
  };

  // --- Delete offer ---
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this offer?")) return;
    try {
      await fetch(`${BASE_URL}/delete/offers/${id}`, { method: "DELETE" });
      fetchOffers();
    } catch (err) {
      console.error("Error deleting offer:", err);
    }
  };

  return (
    <div className="page-container">
      {/* Header */}
      <header className="header">
        <img src={A1} alt="Logo" className="logo" />
        <div className="header-text">
          <h2>Offers Management</h2>
          <p>Manage your discount coupons easily</p>
        </div>
        <button className="btn-logout" onClick={handleBackToDashboard}>Back to Dashboard</button>
      </header>

      {/* Add Offer Button */}
      <div style={{ textAlign: "end", marginBottom: "20px" }}>
        <button className="btn-add-offer" onClick={() => setShowForm(!showForm)}>
          {showForm ? "Close Form" : "Add Offer"}
        </button>
      </div>

      {/* Form */}
      {showForm && (
        <div className="form-card">
          <div className="form-group">
            <label>Offer Title</label>
            <input type="text" placeholder="Enter offer title" value={title} onChange={(e) => setTitle(e.target.value)} />
          </div>

          <div className="form-group">
            <label>Discount %</label>
            <input type="number" placeholder="Enter discount %" value={discount} onChange={(e) => setDiscount(e.target.value)} />
          </div>

          <div className="form-group">
            <label>Offer Image</label>
            <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />
          </div>

          <div className="form-group">
            <label>Start Date</label>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          </div>

          <div className="form-group">
            <label>Expiry Date</label>
            <input type="date" value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} />
          </div>

          <button onClick={handleSubmit}>
            {editingId ? "Update Offer" : "Add Offer"}
          </button>
        </div>
      )}

      {/* Offers Table */}
      <div style={{ marginBottom: "10px", fontWeight: "500" }}>
        Total Offers: {offers.length}
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Discount</th>
              <th>Coupon Code</th>
              <th>Image</th>
              <th>Start Date</th>
              <th>Expiry Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {offers.length === 0 ? (
              <tr>
                <td colSpan="7" className="empty">
                  No offers available
                </td>
              </tr>
            ) : (
              offers.map((offer) => (
                <tr key={offer.id}>
                  <td>{offer.title}</td>
                  <td>{offer.discount}%</td>
                  <td>{offer.coupon}</td>
                  <td>{offer.image && (<img src={offer.image} alt={offer.title} style={{ width: "60px", borderRadius: "4px" }} />)}</td>
                  <td>{formatDateToDisplay(offer.startDate)}</td>
                  <td>{formatDateToDisplay(offer.expiryDate)}</td>
                  <td className="action-buttons">
                    <button className="btn-edit" onClick={() => handleEdit(offer)}><FiEdit size={18} /></button>
                    <button className="btn-delete" onClick={() => handleDelete(offer.id)}><FiTrash2 size={18} /></button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Styles */}
      <style>{`
        .page-container {
          font-family: 'Inter', sans-serif;
          padding: 25px;
          background: #f5f7fa;
          color: #111827;
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }
        .logo {
          height: 70px;
          border-radius: 8px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        }
        .header-text {
          flex: 1;
          text-align: center;
        }
        .header-text h2 {
          margin: 0;
          font-weight: 600;
          font-size: 22px;
        }
        .header-text p {
          margin: 4px 0 0;
          color: #6b7280;
          font-size: 14px;
        }
        .btn-logout {
          background: #ef4444;
          color: white;
          border: none;
          padding: 8px 15px;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.2s;
        }
        .btn-logout:hover { background: #dc2626; }

        .btn-add-offer {
          padding: 12px 20px;
          border: none;
          background: #10b981;
          color: white;
          font-weight: 500;
          cursor: pointer;
          transition: 0.2s;
          border-radius: 8px;
        }
        .btn-add-offer:hover { background: #059669; }

        .form-card {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          padding: 20px;
          background: #ffffff;
          border: none;
          margin-bottom: 20px;
          justify-content: center;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          margin-bottom: 12px;
        }

        .form-group label {
          margin-bottom: 4px;
          font-weight: 500;
          color: #374151;
          font-size: 14px;
        }

        .form-group input {
          padding: 10px;
          width: 200px;
          border: 1px solid #d1d5db;
          border-radius: 4px;
        }

        .form-card button {
          padding: 12px 20px;
          border: none;
          background: #3b82f6;
          color: white;
          font-weight: 500;
          cursor: pointer;
          transition: 0.2s;
          border-radius: 6px;
        }
        .form-card button:hover { background: #2563eb; }

        .table-wrapper {
          overflow-x: auto;
          background: white;
          box-shadow: 0 3px 10px rgba(0,0,0,0.08);
        }
        table {
          width: 100%;
          border-collapse: collapse;
          min-width: 600px;
        }
        th, td {
          padding: 14px 18px;
          text-align: left;
        }
        thead {
          background: #f3f4f6;
          color: #374151;
        }
        tbody tr:hover { background: #f9fafb; }
        td { color: #4b5563; }
        .empty {
          text-align: center;
          padding: 20px;
          color: #9ca3af;
        }
        .action-buttons {
          display: flex;
          gap: 8px;
        }
        .btn-edit, .btn-delete {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          transition: 0.2s;
        }
        .btn-edit { background: #e0f2fe; color: #3b82f6; }
        .btn-edit:hover { background: #3b82f6; color: white; }
        .btn-delete { background: #fee2e2; color: #ef4444; }
        .btn-delete:hover { background: #ef4444; color: white; }

        @media (max-width: 640px) {
          .header { flex-direction: column; text-align: center; }
          .form-card { flex-direction: column; align-items: center; }
          .form-group input { width: 100%; }
        }
      `}</style>
    </div>
  );
};

export default Offers;
